import { render, staticRenderFns } from "./vendor-project-details.vue?vue&type=template&id=b6800acc&scoped=true&"
import script from "./vendor-project-details.vue?vue&type=script&lang=js&"
export * from "./vendor-project-details.vue?vue&type=script&lang=js&"
import style0 from "./vendor-project-details.vue?vue&type=style&index=0&id=b6800acc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6800acc",
  null
  
)

export default component.exports